import { Card, Col, Radio, Row } from 'antd';
import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";

import AddLeave from "./AddLeave";
import AddToil from './AddToil';
import GetToil from './getToil';
import LeaveAllocation from './leaveAllocation';

const Leave = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [formType, setFormType] = useState('Leave');
  const [selectedUserId, setSelectedUserId] = useState(null);

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }
  
  const handleUserChange = (userId) => {
    setSelectedUserId(userId);
  };

  return (
    <>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={24} style={{ padding: 10 }}>
          <Radio.Group onChange={(e) => setFormType(e.target.value)} value={formType}>
            <Radio.Button value="Leave">Leave</Radio.Button>
            <Radio.Button value="Toil">Toil</Radio.Button>
          </Radio.Group>
        </Col>
        {formType === 'Leave' ? (
          <>
            <Col span={8}>
              <Card title="Application for Leave">
                <AddLeave onUserChange={handleUserChange}/>
              </Card>
            </Col>
            <Col span={16}>
              <Card title="Leave Allocation">
                <LeaveAllocation userId={selectedUserId} />
              </Card>
            </Col>
          </>
        ) : (
          <>
          <Col span={8}>
            <Card title="Application for Toil">
              <AddToil />
            </Card>
          </Col>
          <Col span={16}>
          <Card title="Toil">
            <GetToil />
          </Card>
        </Col>
        </>
        )}
      </Row>
    </>
  );
};

export default Leave;
